/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateCheckListRequestViewModel } from "../types/UpdateCheckListRequestViewModel.ts";

export const updateCheckListRequestViewModelSchema = z.object({
  name: z.string().nullish(),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<UpdateCheckListRequestViewModel>;
